import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import { formatDateReadableWithDayOfWeek } from "../../requests/utilities/helpers";
import { get_t_str } from "../../../../helpers/helpers";

function TimeOffCardDeleteModal(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    maxHeight: "90vh",
    bgcolor: "background.paper",
    border: "2px solid #E2E8F0",
    borderRadius: "15px",
    boxShadow: 24,
    p: 4,
    overflowY: "auto",
  };

  const getTimeOffTypeLabel = (type) => {
    switch (type) {
      case "PTO":
        return "Paid Time Off (PTO)";
      case "SICK":
        return "Sick Leave";
      default:
        return "Unpaid";
    }
  };

  return (
    <>
      <Modal
        open={props.open}
        onClose={() => props.handleClose()}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={style}>
          <div className="absolute right-2 top-2">
            <IconButton
              className="text-gray-400 hover:text-gray-600"
              onClick={() => props.handleClose()}
              size="small"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>

          <div>
            <div className="mb-6 flex items-center space-x-3">
              <EventBusyIcon className="text-violet-600 h-7 w-7" />
              <h3 className="text-xl font-semibold text-gray-900">
                Approved Time Off
              </h3>
            </div>

            <div className="p-4 bg-gray-50 rounded-lg mb-6">
              <div>
                <p className="text-gray-500 text-sm font-medium mb-1">Name</p>
                <p className="text-gray-900 font-semibold">
                  {props.p?.first_name} {props.p?.last_name}
                </p>
              </div>
              <div className="mt-4">
                <p className="text-gray-500 text-sm font-medium mb-1">Date</p>
                <p className="text-gray-900 font-semibold">
                  {formatDateReadableWithDayOfWeek(
                    props.timeOffInfo?.date_lower_bound
                  )}
                  {props.timeOffInfo?.date_upper_bound && (
                    <>
                      {" - "}
                      {formatDateReadableWithDayOfWeek(
                        props.timeOffInfo?.date_upper_bound
                      )}
                    </>
                  )}
                </p>
              </div>
              {(props.timeOffInfo?.time_off_type ||
                (props.timeOffInfo?.start_qhnum !== null &&
                  props.timeOffInfo?.end_qhnum !== null)) && (
                <div className="grid grid-cols-2 gap-4 mt-4">
                  {props.timeOffInfo?.time_off_type && (
                    <div>
                      <p className="text-gray-500 text-sm font-medium mb-1">Type</p>
                      <p className="text-gray-900 font-semibold">
                        {getTimeOffTypeLabel(props.timeOffInfo?.time_off_type)}
                      </p>
                    </div>
                  )}
                  {props.timeOffInfo?.start_qhnum !== null &&
                    props.timeOffInfo?.end_qhnum !== null && (
                      <div>
                        <p className="text-gray-500 text-sm font-medium mb-1">Time</p>
                        <p className="text-gray-900 font-semibold">
                          {get_t_str(props.timeOffInfo.start_qhnum)} -{" "}
                          {get_t_str(props.timeOffInfo.end_qhnum)}
                        </p>
                      </div>
                    )}
                </div>
              )}
              {props.timeOffInfo?.title && (
                <div className="mt-4 pt-4 border-t border-gray-200">
                  <p className="text-gray-500 text-sm font-medium mb-1">Title</p>
                  <p className="text-gray-900 font-semibold">
                    {props.timeOffInfo?.title}
                  </p>
                </div>
              )}
              {props.timeOffInfo?.note && (
                <div className="mt-4 pt-4 border-t border-gray-200">
                  <p className="text-gray-500 text-sm font-medium mb-1">Note</p>
                  <p className="text-gray-900">
                    {props.timeOffInfo?.note}
                  </p>
                </div>
              )}
            </div>

            <div className="flex items-center space-x-3">
              <button
                className="flex-1 px-4 py-2.5 rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 transition-colors duration-200 text-sm font-medium"
                onClick={() => props.handleClose()}
              >
                Cancel
              </button>
              <button
                className="flex-1 px-4 py-2.5 rounded-lg bg-rose-600 text-white hover:bg-rose-700 transition-colors duration-200 text-sm font-medium"
                onClick={() => {
                  props.delete_time_off_request(props.timeOffInfo?.uuid);
                  props.handleClose();
                }}
              >
                Delete Time Off
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default TimeOffCardDeleteModal;
